// removed by extract-text-webpack-plugin
module.exports = {"Controls":"resourceList__Controls__2QCNU","Search":"resourceList__Search__1zNvd","ResourceHeader":"resourceList__ResourceHeader__XpMJh","Row":"resourceList__Row__2cUqW","Col":"resourceList__Col__2qld7","Label":"resourceList__Label__1tGpe","Select":"resourceList__Select__3hHeY","SortUIContainer":"resourceList__SortUIContainer__LrpIT","ControlsContainer":"resourceList__ControlsContainer__2rrxn","SortSelection":"resourceList__SortSelection__3RDnj","FilterSelection":"resourceList__FilterSelection__EIAYh","CustomIcon":"resourceList__CustomIcon__1G02e"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/SortUI/resourceList.css
// module id = 964
// module chunks = 2